import { SessionStorageItems } from '@/types/sessionStorageItems';
import {
  CallerIdentityWithOrganizations,
  UserOrganization,
} from '@/types/users';

export const checkIfOrgIsAlreadyActive = (
  myOrgRoles: CallerIdentityWithOrganizations['organizations'],
  orgId: string
) => {
  return !!myOrgRoles[orgId];
};

export const clearSelectedOrgFromStorage = (): void => {
  sessionStorage.removeItem(SessionStorageItems.SELECTED_ORG_DATA);
};

export const writeSelectedOrgAndReload = (
  orgId: string,
  selectedOrg: Pick<UserOrganization, 'roles' | 'employeeId'>,
  // Only true when this selection disambiguates a shared auth0_id across
  // multiple distinct user records (NERV-5621, e.g. multi-tenant isolved),
  // as opposed to a normal switch between orgs under one identity.
  requiresOrgDisambiguationHeader = false
): void => {
  sessionStorage.setItem(
    SessionStorageItems.SELECTED_ORG_DATA,
    JSON.stringify({
      selectedOrg: selectedOrg,
      selectedOrgId: orgId,
      requiresOrgDisambiguationHeader,
    })
  );

  // Reload the page to trigger the initialization flow
  window.location.replace('/');
};

export const handleSwitchOrg =
  ({
    orgId,
    myOrgRoles,
    setError,
    requiresOrgDisambiguationHeader = false,
  }: {
    orgId: string;
    myOrgRoles: {
      [key: string]: UserOrganization;
    };
    setError: (value: React.SetStateAction<boolean>) => void;
    requiresOrgDisambiguationHeader?: boolean;
  }) =>
  () => {
    const selectedOrg = myOrgRoles[orgId];

    if (!selectedOrg) {
      setError(true);
      return;
    }

    writeSelectedOrgAndReload(
      orgId,
      selectedOrg,
      requiresOrgDisambiguationHeader
    );
  };
